import React from 'react';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import './Widget.scss';
import { WidgetCloseButton } from './widget-components/WidgetCloseButton';
import { WidgetLogo } from './widget-components/WidgetLogo';
import { WidgetContent } from './widget-components/WidgetContent';
import { WidgetTitle } from './widget-components/WidgetTitle';
import { HorizontalLine } from './widget-components/HorizontalLine';
import { WidgetList } from './widget-components/WidgetList';
import { WidgetListItem } from './widget-components/WidgetListItem';
import { WidgetTerms } from './widget-components/WidgetTerms';
import { WidgetButton } from './widget-components/WidgetButton';
import { WidgetCancelLink } from './widget-components/WidgetCancelLink';

export interface IWidgetPreviewProps {
	textColor?: string;
	backGroundColor?: string;
	isChecked?: boolean;
	preview?: string;
	fontFamily?: string;
	buttonColorText: string;
	linkColor: string;
	modalRadius?: number;
	buttonRadius?: number;
	onClose?: () => void;
}

export const Widget = (props: IWidgetPreviewProps): React.ReactElement => {
	const {
		textColor,
		backGroundColor,
		isChecked,
		preview,
		fontFamily,
		buttonColorText,
		modalRadius,
		buttonRadius,
		linkColor,
		onClose
	} = props;
	return (
		<div className="ui-widget-dialog" style={{ borderRadius: `${modalRadius}px` }}>
			<WidgetCloseButton onClose={onClose} icon={faXmark}/>
			<WidgetLogo preview={preview} isChecked={isChecked}/>

			<WidgetContent>
				<>
					<WidgetTitle
						textColor={textColor}
						fontFamily={fontFamily}
						text="Your payment of $45.65 has failed but no worries, you can complete your purchase anyway!"
					/>
					<HorizontalLine />
					<WidgetList>
						<>
							<WidgetListItem
								fontFamily={fontFamily}
								textColor={textColor}
								text="Just click OK below to complete your purchase anyway."
							/>
							<WidgetListItem
								fontFamily={fontFamily}
								textColor={textColor}
								text="You will be charged $45.65 when the issue with your payment gets resolved."
							/>
							<WidgetListItem fontFamily={fontFamily} textColor={textColor}>
								<>
									<span>You will be charged $45.65 only.<br/></span>
									<span className="ui-widget-item-bold">No interest, no fees. Ever.</span>
								</>
							</WidgetListItem>
						</>
					</WidgetList>
				</>
			</WidgetContent>
			<WidgetTerms textColor={textColor} fontFamily={fontFamily} linkColor={linkColor}/>
			<WidgetButton
				text="Ok"
				backGroundColor={backGroundColor}
				fontFamily={fontFamily}
				buttonColorText={buttonColorText}
				buttonRadius={buttonRadius}
			/>
			<WidgetCancelLink/>
		</div>
	);
};
